module.exports = __webpack_public_path__ + "img/mapLong_small.8697c118.png";